export default Object.freeze({
  Tokens: 0,
  Duration: 1,
});
